export default __webpack_public_path__ + "static/banner-travel-5-sunny-vacation-c0218c59f3596d3f4643e3020616f225.jpg";